import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('there_is_at_least_one_o_eck_its_not_a_duplicate'),
};
